// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"e_fg","content":"e_gg","container":"e_hg"};